import { BillingTypeMappingConstant } from "presentation/constant/BillingTypeMapping/BillingTypeMappingConstant";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useBillingTypeMappingVM } from "presentation/hook/BillingTypeMapping/useBillingTypeMappingVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useBillingTypeMappingTracked } from "presentation/store/BillingTypeMapping/BillingTypeMappingProvider";
import FileUpload from "presentation/view/components/FileUpload";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import { memo, useCallback, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const BillingTypeMappingTitleBar: React.FC = () => {
    const BILLING_TYPE_MAPPING_CONSTANT = BillingTypeMappingConstant.Title;
    const billingTypeMappingVM = useBillingTypeMappingVM();
    const [billingTypeMappingState] = useBillingTypeMappingTracked();
    const [isLoading, setIsLoading] = useState(false);
    const { updatedRows } = billingTypeMappingState;
    const messageBarVM = useMessageBarVM();
    const [anaInfoState] = useANAInfoTracked();
    const { allowCreate } = anaInfoState;

    const handleAdd = useCallback(() => {
        billingTypeMappingVM.onAddClick();
    }, [billingTypeMappingVM]);

    const handleUpload = useCallback(async (e: any) => {

        const files = e.target?.files;
        const file = files[0];

        if (!file) {
            return;
        }
        if (file.type !== 'text/csv') {
            messageBarVM.showError('Please upload a .csv file');
            return
        }

        setIsLoading(true);
        await billingTypeMappingVM.onUpload(file).then(async res => {

            //file.current.value = null;
            e.target = null;

            if (res.success) {
                messageBarVM.showSuccess("Success!");
                await billingTypeMappingVM.searchAllBillingTypeMappingList().then(data => {
                    setIsLoading(false);
                });
            } else {
                setIsLoading(false);
                messageBarVM.showError(res.data);
            }
        });
    }, [messageBarVM, billingTypeMappingVM]);

    const isApplyDisable = () => {
        if (updatedRows.length !== 0) return false
        return true;
    }

    return <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
        <HeaderTitle>{BILLING_TYPE_MAPPING_CONSTANT.TITLE}</HeaderTitle>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        <StyledAction className="tm-animated-wrapper">
            {(allowCreate) && <><NbisIconButton fileName='Icon-add' disabled={!isApplyDisable()} size='medium' toolTipText={'Add'} toolTipArrow={false} onClick={handleAdd} />
                <div className="add-seperator" /></>}
            <FileUpload handleUpload={handleUpload} label={WorkspaceConstant.Common.BUTTON_UPLOAD} accept=".csv" size={"Small"} theme={"Primary"} disabled={!isApplyDisable()} />
        </StyledAction>
    </Sidebarheader>
}

export default memo(BillingTypeMappingTitleBar);